import { Box, Button, Snackbar } from '@coolblue-development/freddy';
import config from '../../../../config';
import { useSnackbar } from '../../../../utils/hooks/useSnackbar';
import { resetRoutingProfiles } from '../../../../services/resetRoutingProfiles';

interface AgentsDashboardFooterProps {
  selectedAgentIds: (string | number)[];
  onChangeChannel: () => void;
  onSetDefaultRoutingProfile: () => void;
  handleRefetch: () => void;
}

export const AgentsDashboardFooter = ({
  selectedAgentIds,
  onChangeChannel,
  onSetDefaultRoutingProfile,
  handleRefetch
}: AgentsDashboardFooterProps): JSX.Element => {
  const { environment } = config;
  const isTestingEnv = environment === 'development' || environment === 'testing';
  const { snackbar, show, hideSnackbar } = useSnackbar();

  const handleReset = async (activeOnly: boolean): Promise<void> => {
    try {
      await resetRoutingProfiles(activeOnly);
      handleRefetch();
      show('Routing profiles reset successfully', 'success');
    } catch (error) {
      show(`Error resetting routing profiles: ${(error as Error).message}`, 'error');
    }
  };

  return (
    <Box
      sx={{
        padding: '20px',
        display: 'flex',
        gap: '5px',
        borderTop: '#DDDDDD 1px solid',
        boxShadow: '0px 3px 15px 0px #13171E1A'
      }}
    >
      <Button onClick={onChangeChannel} disabled={selectedAgentIds.length === 0}>
        Change routing profile
      </Button>
      <Button variant="secondary" onClick={onSetDefaultRoutingProfile} disabled={selectedAgentIds.length === 0}>
        Set default routing profile
      </Button>
      {isTestingEnv && (
        <>
          <Button sx={{ marginLeft: 'auto', marginRight: '16px' }} size="small" onClick={() => void handleReset(false)}>
            Reset All Agent Profiles
          </Button>
          <Button size="small" onClick={() => void handleReset(true)}>
            Reset Active Agent Profiles
          </Button>
          <Snackbar {...snackbar} onClose={hideSnackbar} placement="bottom" />
        </>
      )}
    </Box>
  );
};
